import module from 'fanconsultores/module.js'
import template from './template.html'
import enUsTemplate from './en_US/template.html'
import esMxTemplate from './es_MX/template.html'

const templates = {
  en_US: enUsTemplate,
  es_MX: esMxTemplate,
}

class FanAdminAboutPoliticasComponent {
  constructor ($sce, $translate) {
    this.$sce = $sce
    this.$translate = $translate
  }

  $onInit () {
    const lang = this.$translate.proposedLanguage() || this.$translate.use()
    this.template = this.$sce.trustAsHtml(templates[lang])
  }
}

module.component('fanAdminAboutPoliticas', {
  controller: FanAdminAboutPoliticasComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fan/admin/about/politicas/component.js